import { createAsyncThunk } from "@reduxjs/toolkit";
import apiConfig from "constants/apiConfig";
import { fetchBrands } from "services/api/brands";
import { AuthState } from "slices/auth/reducer";
import { ERROR } from "types";
import { BrandListPayload, BrandListResponse, BrandListSlice } from "types/brand";
import { isFresh } from "utils/helpers";

const STALE_TIME = apiConfig.FETCH_BRANDS.staleTime;

export const fetchBrandList = createAsyncThunk<{brandList: BrandListResponse, page: number}, BrandListPayload, {rejectValue: string}>(
    'brands/list',
    async ({ page, force = false }, { getState, rejectWithValue }) => {
        const state = getState() as { brandList: BrandListSlice, auth: AuthState };
        if (page === 1 && !force && isFresh(state.brandList.last_fetched_at, STALE_TIME) && !state.brandList.expired) {
            return rejectWithValue(ERROR.CACHED);
        }
        try {
            const brandList = await fetchBrands(state.auth.selectedAgencyId!, {page});
            return { brandList, page };
        } catch (error) {
            return rejectWithValue(ERROR.NOT_FOUND);
        }
    }
);